import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'

const NotFound = () => {

	const App = useApp()

	useEffect(() => {
		App.setShowNav(true)
		App.setHeader({
			title: App.appName,
			show: true
		})
	}, [])

	return (
		<div className="padding">
			페이지를 찾을 수 없습니다.	
		</div>
	)
}

export default NotFound